import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import Loader from "../../../components/common/loader";
import { BreadCrumb } from "primereact/breadcrumb";
import { ReactComponent as HomeIcon } from "../../../assets/images/home.svg";

import { getFaqById } from "../../../services/app.faq.service";
import { toast } from "react-toastify";

const FaqDetails = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [faqData, setFaqData] = useState<any>({});

  const getFaqDetail = async (id: number) => {
    setLoading(true);
    try {
      const response = await getFaqById(id);
      if (response.statusCode === 200) {
        setFaqData(response?.data);
      } else {
        toast.error(response.msg || "Failed to load FAQ details.");
      }
    } catch (err: any) {
      toast.error("Error fetching FAQ details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getFaqDetail(Number(id));
    }
  }, [id]);

  const items = [{ label: "FAQs" }, { label: `FAQ Details` }];
  const home = {
    icon: <HomeIcon style={{ width: "1rem", height: "1rem" }} />,
    url: "/dashboard",
  };

  return (
    <React.Fragment>
      <Loader isLoading={loading} />
      <Card className="overflow-auto border-0 rounded-bottom-0 h-100 page-card-content px-3 pt-3">
        <Card.Header className="fs-5 fw-semibold  d-flex flex-wrap gap-2 align-items-center bg-body-tertiary border-0 px-0 pt-0 pb-3">
          <div className="w-100">
            <BreadCrumb model={items} home={home} />
          </div>
          <div className="w-100 d-flex flex-wrap align-items-center justify-content-between mt-3">
            <h5 className="mb-0 me-auto fw-bold text-uppercase">FAQs</h5>
          </div>
        </Card.Header>

        <Card.Body className="overflow-auto">
          <h5 className="opacity-75 fw-semibold fs-18 mb-4">FAQ Details</h5>
          <Row>
            <Col sm={12} md={12}>
              <div className="mb-3 pb-1">
                <label className="mb-1 small fs-14 fw-semibold d-inline-flex lh-sm gap-1 form-label">
                  <span>Question</span>
                </label>
                <div className="position-relative w-100 ">
                  <p className="mb-0">{faqData.question}</p>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col sm={12} md={12}>
              <div className="mb-3 pb-1">
                <div className="mb-3 pb-1">
                  <label className="mb-1 small fs-14 fw-semibold d-inline-flex lh-sm gap-1 form-label">
                    <span>Answer</span>
                  </label>
                  <div className="position-relative w-100 ">
                    <p className="mb-0">{faqData.answer}</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
        <Card.Footer className="d-flex flex-wrap gap-3 justify-content-end py-3 border-top">
          <Link to="/faqs" className="btn btn-outline-secondary">
            Back
          </Link>
        </Card.Footer>
      </Card>
    </React.Fragment>
  );
};

export default FaqDetails;
